import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const BASENAME = import.meta.env.BASE_URL;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB.replace(/^\//, "");

const ScheduleAttendanceInfoService = {
    getSchedule: async (id) => axios.get(API_URL + `/reports/schedule_attendance_info/${id}/data`).then(({ data }) => data).catch((err) => { throw err }),

    getDispatch: (id) => `${BASENAME}${API_DESPACHO_WEB}/dispatch/form/${id}`,

    getOccurrence: (id) => `${BASENAME}bo/show/${String(id).replace(/\//g, "-")}`,

    getAttach: (referenceId) => API_KEEPER + `/ged/attach/${referenceId}`,

    getImage: (extension) => API_URL + `/public/assets/img/file-types/${extension}.png`,
}

export default ScheduleAttendanceInfoService;
